import type { Merchant } from '@tectonics/prs/merchant';
import { getMerchantConfig } from '@tectonics/prs/merchant';

export function shouldHideUsdAmountOnCheckout(merchant: Merchant): boolean {
  const merchantConfig = getMerchantConfig(merchant);

  return merchantConfig
    ? Boolean(merchantConfig.hide_usd_amount_on_checkout)
    : false;
}
